import { render, staticRenderFns } from "./ListFiltroModalItemInputTransportadora.vue?vue&type=template&id=71a33dbd"
import script from "./ListFiltroModalItemInputTransportadora.vue?vue&type=script&lang=js"
export * from "./ListFiltroModalItemInputTransportadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports